import { InjectionToken } from '@angular/core';

export const PREVIEW_MODE = new InjectionToken<boolean>('PREVIEW_MODE', {
  providedIn: 'root',
  factory: () => false
});